import { ButtonProps } from '@mui/material';
import { TDocFile } from 'shared/constants/docs';

type FileSyncButtonProps = Omit<ButtonProps, 'onClick' | 'children'> & {
	files: Pick<TDocFile, '_id' | 'projectId' | 'cloud' | 'path' | 'systemType'>[];
	callback?: () => void;
};

/** Sync is available in the desktop app only. */
export default function FileSyncButton(_props: FileSyncButtonProps) {
	return null;
}
